import * as React from 'react';
import { DataLayer } from '@grandvisionhq/analytics';
import { MediaQuery } from '@grandvisionhq/common';
import { useAddToProductViewHistory } from '@grandvisionhq/fun-products';
import { useReviewsContext, Actions } from '@grandvisionhq/reviews';
import { useIntl, useFeatureToggles } from '@grandvisionhq/state';
import { pushPdpEventToDataLayer } from '../../utils/DataLayer/data-layer.js';
import { CTAButton } from './Components/CTAButton/CTAButton.js';
import PackageSelector from './Components/PackageSelector/PackageSelector.js';
import { triggerDataLayerEvent, EventAction } from './data-layer-utils.js';
import Solutions$1 from './Solutions.js';
import { useProductDetailContext } from '../Context/ProductDetailContext.js';
import { useBrandLink } from '../utils/use-brand-link.js';

const DEFAULT_SOLUTION_MAX_QUANTITY = 5;
const SolutionsContainer = ({ activeSku , addToCartRef , variant , product , showStickyButton , onCTAClick ,  })=>{
    const isSmallScreen = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
    const { clAndSolutionsMaxOrderableQuantity  } = useProductDetailContext();
    const { currency , getLabel  } = useIntl();
    const { availability  } = variant;
    const variants = React.useMemo(()=>[
            product.masterVariant,
            ...product.variants
        ]
    , [
        product.masterVariant,
        product.variants
    ]);
    const { isProductLabelEnabled  } = useFeatureToggles();
    useAddToProductViewHistory({
        variant,
        variants
    });
    const reviews = useReviewsContext();
    React.useEffect(()=>{
        if (reviews.enabled) {
            reviews.dispatch(Actions.updateReviewDisplay({
                variantId: activeSku
            }));
        }
    }, [
        activeSku,
        reviews
    ]);
    React.useEffect(()=>{
        pushPdpEventToDataLayer(DataLayer.DataLayerTypes.PurchaseType.OneTime, product, activeSku, currency);
    }, [
        activeSku
    ]);
    const [selectedQuantity, setSelectedQuantity] = React.useState(1);
    var ref;
    const availableQuantity = (ref = availability === null || availability === void 0 ? void 0 : availability.availableQuantity) !== null && ref !== void 0 ? ref : 0;
    const maxOrderableQuantity = clAndSolutionsMaxOrderableQuantity !== null && clAndSolutionsMaxOrderableQuantity !== void 0 ? clAndSolutionsMaxOrderableQuantity : DEFAULT_SOLUTION_MAX_QUANTITY;
    const isOrderable = (variant === null || variant === void 0 ? void 0 : variant.channelAvailability) === 'ONLINE';
    const onIncreaseQuantity = React.useCallback(()=>(setSelectedQuantity((prevSelectedQuantity)=>prevSelectedQuantity + 1
        ), triggerDataLayerEvent(EventAction.QuantityIncrease))
    , []);
    const onDecreaseQuantity = React.useCallback(()=>(setSelectedQuantity((prevSelectedQuantity)=>prevSelectedQuantity - 1
        ), triggerDataLayerEvent(EventAction.QuantityDecrease))
    , []);
    const brandLink = useBrandLink(product);
    const brandModel = `${variant.contactLensCareType} ${variant.packageOption}`;
    const labels = {
        selectAmount: getLabel('products.solutions.selectAmount'),
        selectVolume: getLabel('products.solutions.selectVolume')
    };
    var _discountedPrice;
    const calculatedTotalPrice = selectedQuantity > 1 ? selectedQuantity * ((_discountedPrice = variant.price.discountedPrice) !== null && _discountedPrice !== void 0 ? _discountedPrice : variant.price.originalPrice) : null;
    const ctaButton = /*#__PURE__*/ React.createElement(CTAButton, {
        isOrderable: isOrderable,
        activeSku: activeSku,
        calculatedPrice: calculatedTotalPrice,
        currency: currency,
        selectedQuantity: selectedQuantity,
        addToCartCallback: onCTAClick
    });
    const packageSelector = React.useMemo(()=>{
        const handleVariantPickAndEvent = (pickedSolutionsVolume)=>{
            triggerDataLayerEvent(EventAction.SelectVolume, pickedSolutionsVolume);
        };
        return variants.length > 1 ? /*#__PURE__*/ React.createElement(PackageSelector, {
            variants: variants,
            label: labels.selectVolume,
            selectedPackage: activeSku,
            handleVariantPick: handleVariantPickAndEvent,
            className: "product-detail-solutions__package-selector"
        }) : null;
    }, [
        activeSku,
        labels.selectVolume,
        variants
    ]);
    return /*#__PURE__*/ React.createElement(Solutions$1, {
        addToCartRef: addToCartRef,
        availableQuantity: availableQuantity,
        brandLink: brandLink,
        brandModel: brandModel,
        currency: currency,
        ctaButton: ctaButton,
        isSmallScreen: isSmallScreen,
        labels: labels,
        showStickyButton: showStickyButton,
        variant: variant,
        packageSelector: packageSelector,
        selectedQuantity: selectedQuantity,
        onDecreaseQuantity: onDecreaseQuantity,
        onIncreaseQuantity: onIncreaseQuantity,
        isOrderable: isOrderable,
        isProductLabelEnabled: isProductLabelEnabled,
        maxOrderableQuantity: maxOrderableQuantity,
        allowBackOrder: variant.allowBackOrder,
        quantity: selectedQuantity
    });
};
var Solutions = SolutionsContainer;

export { SolutionsContainer, Solutions as default };
//# sourceMappingURL=SolutionsContainer.js.map
